module.exports = __webpack_public_path__ + "img/Retention-risks@3x.65cec45e.png";